/* Bottle add-on in the cart drawer and on /cart. Adds through Shopify's own cart
   endpoint, so Shopify analytics and the Meta pixel see a normal add to cart. */
(function () {
  if (window.__mobCartAddon) return;
  window.__mobCartAddon = true;

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('[data-cart-addon-form]');
    if (!form) return;
    event.preventDefault();

    var box = form.closest('[data-cart-addon]');
    var button = form.querySelector('button[type="submit"]');
    var error = box && box.querySelector('.cart-addon__error');
    var variantId = parseInt(form.elements.id.value, 10);

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function () {
        // Same event the theme uses after its own cart changes: refreshes the
        // drawer / cart page contents and the header count, no reload.
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      })
      .catch(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (error) error.hidden = false;
      });
  });
})();
